export default __webpack_public_path__ + "static/media/contact-dark.36230850.svg";